/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-07-13
 */

export enum STATUS {
  NOT_STARTED = "NOT STARTED",
  PENDING = "PENDING",
  // Value kept as 'SUCESS' to match what old-store reducers write; typo lives in the string only.
  SUCCESS = "SUCESS",
  FAILED = "FAILED",
}
